import { get, head, map, keys, pick } from 'lodash';

import CartLineItem from 'models/CartLineItem';
import ACTIONS from 'state/constants';
import { getCurrentProduct, getCurrentVariant } from 'state/selectors/pdp';
import DynamicYield from 'utils/DynamicYield';

const getItem = (state, id) => get(state, ['ajaxCart', 'data', 'entities', 'item', id]);

const formatCartItems = cartItems => {
  return map(cartItems, item => {
    const cartItem = new CartLineItem(item);
    const { sku, price, quantity } = cartItem;

    return {
      productId: sku,
      quantity,
      itemPrice: DynamicYield.formatPriceToFloat(price),
    };
  });
};

const updateProductDetails = (store, next, action) => {
  // Perform Action
  next(action);

  const state = store.getState();
  const product = getCurrentProduct(state);
  const currentVariant = getCurrentVariant(state);
  let sku;

  if (currentVariant) {
    sku = get(currentVariant, 'sku');
  } else {
    const firstSize = head(get(product, 'sizesSortOrder'));
    sku = get(product, ['sizes', firstSize, 'sku']);
  }

  if (sku) {
    DynamicYield.updateContext('PRODUCT', [sku]);
  }
};

const addToCart = (store, next, action) => {
  // Perform Action
  next(action);

  const state = store.getState();

  const cartItems = get(action, ['payload', 'cart', 'entities', 'item']);
  const mappedCartItems = formatCartItems(cartItems);

  const itemIds = keys(get(action, ['payload', 'addedItems']));
  return map(itemIds, itemId => {
    const item = new CartLineItem(getItem(state, itemId));

    const pickedItem = pick(item, ['sku', 'size', 'price', 'quantity']);

    DynamicYield.pushAddToCart(pickedItem, mappedCartItems);
  });
};

const removeFromCart = (store, next, action) => {
  const state = store.getState();

  const cartItems = get(action, ['payload', 'cart', 'entities', 'item']);
  const mappedCartItems = formatCartItems(cartItems);

  const itemId = get(action, ['payload', 'removedItem']);
  const item = new CartLineItem(getItem(state, itemId));
  const pickedItem = pick(item, ['sku', 'size', 'price', 'quantity']);

  DynamicYield.pushRemoveFromCart(pickedItem, mappedCartItems);

  // Perform Action after item pulled from state
  next(action);
};

const updateCartItem = (store, next, action) => {
  const cartItems = get(action, ['payload', 'cart', 'entities', 'item']);
  const mappedCartItems = formatCartItems(cartItems);

  DynamicYield.syncCartEvent(mappedCartItems);

  // Perform Action
  next(action);
};

const signUpForEmail = (store, next, action) => {
  const emailAddress = get(action, ['payload', 'emailAddress']);
  DynamicYield.emailNewsletterEvent(emailAddress);
};

const dynamicYieldPusher = store => next => action => {
  switch (action.type) {
    case ACTIONS.SET_CURRENT_PRODUCT:
    case ACTIONS.SET_CURRENT_SIZE:
      updateProductDetails(store, next, action);
      break;
    case ACTIONS.ADD_LINE_ITEMS_SUCCESS:
      addToCart(store, next, action);
      break;
    case ACTIONS.REMOVE_LINE_ITEM_SUCCESS:
      removeFromCart(store, next, action);
      break;
    case ACTIONS.UPDATE_LINE_ITEM_SUCCESS:
      updateCartItem(store, next, action);
      break;
    case ACTIONS.SIGN_UP_NEWSLETTER_REQUEST:
      signUpForEmail(store, next, action);
      break;
    default:
      next(action);
  }
};

export default dynamicYieldPusher;
